<script>
import cloneDeep from 'lodash.clonedeep';
import Layout from '@layouts/main';
import DriverForm from '@views/drivers/form';
import LeavesIndex from '@views/leaves/index-driver.vue';
import beforeLeaveAfterEdit from '@mixins/beforeLeaveAfterEdit';

export default {
  name: 'DriverEdit',
  components: {
    Layout,
    DriverForm,
    LeavesIndex,
  },
  mixins: [beforeLeaveAfterEdit],
  page() {
    return {
      title: `${this.$t('titles.edit_driver')} #${this.$route.params.id}`,
    };
  },
  props: {
    user: {
      type: Object,
      required: true,
      default: null,
    },
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('titles.home'),
          to: { name: 'home.index' },
        },
        {
          text: this.$t('titles.drivers'),
          to: { name: 'drivers.index' },
        },
        {
          text: `${this.$t('titles.edit_driver')} #${this.$route.params.id}`,
          active: true,
        },
      ],
      leavesLocal: [],
      initialLocations: [],
    };
  },
  mounted() {
    this.leavesLocal = cloneDeep(this.user.leaves);
    this.initialLocations = cloneDeep(this.user.locations);
  },
  methods: {
    update(callback) {
      this.setUnchanged();
      if (!callback) {
        this.$router.push({
          name: 'drivers.index',
        });
      }
    },
    updateItemInList(name, item, key) {
      this.$set(this[name], key, item);
    },
    deleteItemFromList(name, id, key) {
      this[name].splice(key, 1);
    },
  },
};
</script>

<template>
  <Layout>
    <b-breadcrumb :items="breadcrumbItems" />
    <DriverForm v-model="user" :loaded-id="user.id"  :initial-locations="initialLocations" @submitted="update" @entity-changed="initBeforeLeave" />
    <b-card
      border-variant="dark"
      :header="$t('titles.leaves')"
      header-tag="header"
      header-bg-variant="dark"
      header-text-variant="white"
    >
      <LeavesIndex
        :leaves="leavesLocal"
        @updated="updateItemInList('leavesLocal', ...arguments)"
        @deleted="deleteItemFromList('leavesLocal', ...arguments)"
      />
    </b-card>
  </Layout>
</template>
